


import useBaseApiHook, { BASE_API_CONSTANT } from "services/useBaseApiHook"


const REPO_URL_PREFIX = '/User'
const REPO_URL = {
    // getUserDataLogin: `${REPO_URL_PREFIX}/get-current-user-data`,
    // getMenu: `${REPO_URL_PREFIX}/list-current-user-available-menu-as-tree`,
    // changePassword: `${REPO_URL_PREFIX}/change-password`,
    // getUserList: `${REPO_URL_PREFIX}/search`,
    // getUserById: `${REPO_URL_PREFIX}/get-by-id`,
    // create: `${REPO_URL_PREFIX}/create`,
    // update: `${REPO_URL_PREFIX}/update`,
    // getUserRole: `${REPO_URL_PREFIX}/user-has-role`,
    // getUserWfRole: `${REPO_URL_PREFIX}/user-has-wfrole`,
    // sendLinkResetPassword: `${REPO_URL_PREFIX}/send-link-reset-password`,
    // sendLinkResetPasswordByUser: `${REPO_URL_PREFIX}/send-link-reset-password-by-user`,
    // resetPassword: `${REPO_URL_PREFIX}/reset-password`,
    // getUserByUserId: `${REPO_URL_PREFIX}/user-employee-name`,
    // checkPrivilegeUser: `${REPO_URL_PREFIX}/user-have-privilage`,
    getList: '/user/paginated',
    getById: '/user/id',
    create: '/user/save',
    update: '/user/update',
    delete: '/user/delete',
}

const useUserRepo = (initialLoading = false, showError = true) => {
    const { isLoading, data, error, executeApi } = useBaseApiHook(initialLoading, showError)

    const getUserList = async (payload) => {
          
            return await executeApi(REPO_URL.getList, BASE_API_CONSTANT.METHOD.POST, payload)
        }
    
        const getUserById = async (payload) => {
            return await executeApi(REPO_URL.getById, BASE_API_CONSTANT.METHOD.POST, payload)
        }
    
        const createUser = async (payload) => {
            return await executeApi(REPO_URL.create, BASE_API_CONSTANT.METHOD.POST, payload)
        }
    
        const updateUser = async (payload) => {
            return await executeApi(REPO_URL.update, BASE_API_CONSTANT.METHOD.POST, payload)
        }
    
        const deleteUser = async (payload) => {
            return await executeApi(REPO_URL.delete, BASE_API_CONSTANT.METHOD.POST, payload)
        }

    // const getUserDataLogin = async () => {
    //     return await executeApi(REPO_URL.getUserDataLogin, BASE_API_CONSTANT.METHOD.POST)
    // }

    // const getMenu = async () => {
    //     return await executeApi(REPO_URL.getMenu, BASE_API_CONSTANT.METHOD.POST)
    // }

    // const changePassword = async (payload) => {
    //     return await executeApi(REPO_URL.changePassword, BASE_API_CONSTANT.METHOD.POST, payload)
    // }

    // const getUserList = async (payload) => {
    //     return await executeApi(REPO_URL.getUserList, BASE_API_CONSTANT.METHOD.POST, payload)
    // }

    // const getUserById = async (payload) => {
    //     return await executeApi(REPO_URL.getUserById, BASE_API_CONSTANT.METHOD.POST, payload)
    // }

    // const create = async (payload) => {
    //     return await executeApi(REPO_URL.create, BASE_API_CONSTANT.METHOD.POST, payload)
    // }

    // const update = async (payload) => {
    //     return await executeApi(REPO_URL.update, BASE_API_CONSTANT.METHOD.POST, payload)
    // }

    // const getUserRole = async (payload) => {
    //     return await executeApi(REPO_URL.getUserRole, BASE_API_CONSTANT.METHOD.POST, payload)
    // }

    // const getUserWfRole = async (payload) => {
    //     return await executeApi(REPO_URL.getUserWfRole, BASE_API_CONSTANT.METHOD.POST, payload)
    // }

    // const sendLinkResetPassword = async (payload) => {
    //     return await executeApi(REPO_URL.sendLinkResetPassword, BASE_API_CONSTANT.METHOD.POST, payload)
    // }

    // const resetPassword = async (payload) => {
    //     return await executeApi(REPO_URL.resetPassword, BASE_API_CONSTANT.METHOD.POST, payload, { isUnauthenticated: true })
    // }

    // const getUserByUserId = async (payload) => {
    //     return await executeApi(REPO_URL.getUserByUserId, BASE_API_CONSTANT.METHOD.POST, payload, { isUnauthenticated: true })
    // }

    // const sendLinkResetPasswordByUser = async (payload) => {
    //     return await executeApi(REPO_URL.sendLinkResetPasswordByUser, BASE_API_CONSTANT.METHOD.POST, payload, { isUnauthenticated: true })
    // }

    // const checkPrivilegeUser = async (payload) => {
    //     return await executeApi(REPO_URL.checkPrivilegeUser, BASE_API_CONSTANT.METHOD.POST, payload)
    // }

    return {
        isLoading,
        data,
        error,
        getUserList,
        getUserById,
        createUser,
        updateUser,
        deleteUser
        // getUserDataLogin,
        // getMenu,
        // changePassword,
        // getUserList,
        // getUserById,
        // create,
        // update,
        // getUserRole,
        // getUserWfRole,
        // sendLinkResetPassword,
        // resetPassword,
        // getUserByUserId,
        // sendLinkResetPasswordByUser,
        // checkPrivilegeUser
    }
}

export default useUserRepo
